import styled from 'styled-components'

export const Info = styled.span`
  ${({ theme }) => `
    color: ${theme.color.grey};
  `}
`
